<app-field-viewer *ngIf="environment['Magazzino'] && environment['Magazzino']['CampiLista']" [Campi]="environment['Magazzino']['CampiLista']" [(Type)]="Tipo" [(Oggetto)]="Object" (OnChange)="ChangeHandler($event)"></app-field-viewer>
<div class="card" *ngIf="!environment['Magazzino'] || !environment['Magazzino']['CampiLista']">
  <div class="card-body">
    <h4>
      <span class=" px-3 font-weight-bold font-14">Inserire nell'environment il campo 'Magazzino.CampiLista'</span>
    </h4>
  </div>
</div>
